import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint, NavSupportedEnvironment } from '@retailer-platform/dashboard/routing'
import { fulfillmentPartnerIntegrationsRouter } from './routing/fulfillmentPartnerIntegrationsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { responseConfigurationPageAccessControl } from './access-control/responseConfigurationPageAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'fulfillment-partner-integrations',
  totem: {
    tool: 'fulfillment-partner-integrations-dashboard-tool',
    hasDevTooling: true,
  },
  routes,
  translations: { EN_US },
  routers: {
    scoped: [fulfillmentPartnerIntegrationsRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.Developer,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Fulfillment partner integration for mocking responses',
          route: 'fulfillment-partner-integrations-response-configurations-list',
          labelId: 'fulfillmentPartnerIntegrationsDomain.responseConfigurationsListPage.title',
          position: 3,
          positionNavV2: 3,
          // this is ignored when developing locally
          environment: NavSupportedEnvironment.Dev,
          accessControl: responseConfigurationPageAccessControl,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
